export default "__VITE_PUBLIC_ASSET__da3bd0b0__"